module.exports = __webpack_public_path__ + "img/email-sent.2eb16483.svg";